// extracted by mini-css-extract-plugin
export default {"sidenav":"sb_sidenav__erOPE","mn":"sb_mn__FPJgV","ht":"sb_ht__DZMii","closebtn":"sb_closebtn__mh6a6","main":"sb_main__F5Pxd"};